/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AggregatedCurveFilter {
  accountId?: number;
  pairId: number;
  fromTime: string;
  toTime: string;
  priceType: AggregatedCurveFilter.PriceTypeEnum;
  /**
   * Cost in quote asset
   */
  minCost?: number;
  /**
   * Cost in quote asset
   */
  maxCost?: number;
  /**
   * Which hours we include into report. [0,2,3] - means UTC [0.00 - 1.00] + [2.00 - 3.00] + [3.00 - 4.00]
   */
  includeHours: Array<number>;
  /**
   * Step - 10 ms. Example: [-1000, -100, 0, 100, 500]
   */
  offsetsInMs: Array<number>;
  /**
   * LP ids.
   */
  csvExportLpIds?: Array<number>;
  /**
   * LP ids to group into Best expected virtual LP.
   */
  lpIdsToGroup?: Array<number>;
  useClientTradePrice?: boolean;
  algoInitiatorIds?: Array<number>;
}
export namespace AggregatedCurveFilter {
  export const PriceTypeEnum = {
    Mid: 'MID',
    Best: 'BEST',
    Expected: 'EXPECTED',
  } as const;
  export type PriceTypeEnum = (typeof PriceTypeEnum)[keyof typeof PriceTypeEnum];
}
